import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions(["deleteCustomer"]),
    async handleDeleteCustomer(customer) {
      const confirmationResult = await this.$swal({
        title: this.$t("message.areYouSure"),
        text: this.$t("message.deleteCustomerConfirmationText"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("message.confirm"),
        cancelButtonText: this.$t("message.cancel")
      });

      if (!confirmationResult.value) return;

      this.loader = this.$loading.show();

      try {
        await this.deleteCustomer(customer._id);
        this.$notify({
          type: "success",
          title: this.$t("message.success"),
          text: this.$t("message.deleteCustomerSuccess")
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          title: this.$t("message.error"),
          text: this.$t("message.deleteCustomerFailure") + `${error.message}.`
        });
      } finally {
        this.loader.hide();
        this.loader = null;
      }
    }
  }
};
